<template>
  <v-row>
    <about-component
      v-for="biodata in biodatas"
      :key="biodata.id"
      :biodata="biodata"
    >
    </about-component>
  </v-row>
</template>


<script>
import AboutComponentVue from "../components/AboutComponent.vue";
export default {
  data: () => ({
    biodatas: [
      {
        id: 1,
        nama: "Muhammad Izzah Aeman",
        notelp: "081252632749",
        picts: "1.jpg",
      },
      {
        id: 2,
        nama: "Muhammad Syawaldin Mintang",
        notelp: "085396332985",
        picts: "2.jpg",
      },
      {
        id: 3,
        nama: "Muhammad Shidqi",
        notelp: "082176991834",
        picts: "3.jpg",
      },
    ],
  }),
  components: {
    "about-component": AboutComponentVue,
  },
};
</script>